import { render, staticRenderFns } from "./EditRoleTemplateDialog.vue?vue&type=template&id=5e0abc8a&"
import script from "./EditRoleTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./EditRoleTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports